import tw, { css, styled } from "twin.macro";

export const stylesWrapperCard = css`
  ${tw`shadow-elevation-0 flex flex-col gap-s p-s
    min-[750px]:(gap-sm p-sm)
    large:(gap-m p-m)
  `}
`;

export const StyledWrapperMiscellaneousContent = styled.div`
  ${tw`flex flex-col gap-xs
    min-[750px]:(flex-row gap-s)
  `}
`;

export const StyledWrapperMiscellaneousWrapperCardContent = styled.div`
  ${tw`flex flex-col gap-xs flex-1`}

  & > a, & > div {
    ${tw`w-full flex-1`}
  }
`;

export const StyledWrapperMiscellaneousWrapperCard = styled.div`
  ${tw`max-[500px]:(flex-col)  flex flex-1 gap-xs`}

  &.reverse {
    ${tw`max-[500px]:(flex-col-reverse)  min-[750px]:(flex-row-reverse)`}
  }
`;
